import { ref, computed } from 'vue';

/**
 * Composable for managing notifications
 * @returns {Object} Notifications state and methods
 */
export default function useNotifications() {
  const notifications = ref([]);
  const isOpen = ref(false);

  // Count of unread notifications
  const unreadCount = computed(() => {
    return notifications.value.filter(n => !n.read).length;
  });

  // Check if there are any unread notifications
  const hasUnread = computed(() => unreadCount.value > 0);

  // Toggle the notifications panel
  const togglePanel = () => {
    isOpen.value = !isOpen.value;
  };

  // Close the notifications panel
  const closePanel = () => {
    isOpen.value = false;
  };

  // Add a new notification
  const addNotification = (notification) => {
    notifications.value.unshift({
      id: Date.now().toString(),
      read: false,
      createdAt: new Date(),
      ...notification
    });
  };

  // Mark a notification as read
  const markAsRead = (notificationId) => {
    const notification = notifications.value.find(n => n.id === notificationId);
    if (notification) {
      notification.read = true;
    }
  };

  // Mark all notifications as read
  const markAllAsRead = () => {
    notifications.value.forEach(notification => {
      notification.read = true;
    });
  };

  // Remove a notification
  const removeNotification = (notificationId) => {
    notifications.value = notifications.value.filter(n => n.id !== notificationId);
  };

  // Clear all notifications
  const clearAll = () => {
    notifications.value = [];
  };

  return {
    notifications,
    isOpen,
    unreadCount,
    hasUnread,
    togglePanel,
    closePanel,
    addNotification,
    markAsRead,
    markAllAsRead,
    removeNotification,
    clearAll
  };
}